import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=455f6b54"
import script from "./ContentImage.vue?vue&type=script&lang=js"
export * from "./ContentImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports